// DayPasses action types

const dayPassesActionTypes = {
  SET_DAYPASSES: 'SET_DAYPASSES',
  GET_SEASON_PASS_INFO_LOADING: 'GET_SEASON_PASS_INFO_LOADING',
  GET_SEASON_PASS_INFO_SUCCESS: 'GET_SEASON_PASS_INFO_SUCCESS',
  GET_SEASON_PASS_INFO_ERROR: 'GET_SEASON_PASS_INFO_ERROR',
  GET_SEASON_PASS_CHARGES_LOADING: 'GET_SEASON_PASS_CHARGES_LOADING',
  GET_SEASON_PASS_CHARGES_SUCCESS: 'GET_SEASON_PASS_CHARGES_SUCCESS',
  GET_SEASON_PASS_CHARGES_ERROR: 'GET_SEASON_PASS_CHARGES_ERROR',
  CLEAR_DAYPASSES: 'CLEAR_DAYPASSES'
};

export default dayPassesActionTypes;
